import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { View, Stack, SlideImage, FadeImage } from "./"

const FadeIfLink = styled(View)`
  ${({ href }) =>
    href
      ? `
  :hover {
    opacity: 0.7;
  }
  transition: opacity 300ms ease-in-out;
`
      : null}
`

const ImageContainer = ({ children, ...rest }) => (
  <FadeIfLink style={{ background: "#eee", display: "block" }} {...rest}>
    <div style={{ paddingBottom: "100%", position: "relative" }}>
      {children}
    </div>
  </FadeIfLink>
)

export default ({ style, slides, images }) => {
  const ref = useRef(null)
  const isIntersecting = useOnScreen(ref)
  return (
    <Stack gridTemplateColumns="1fr 1fr 1fr" style={style} ref={ref}>
      {images &&
        isIntersecting &&
        images.map((image, index) => (
          <ImageContainer key={index} as="a" href={image.link} target="_blank">
            <FadeImage src={image.url} alt="" />
          </ImageContainer>
        ))}
      {slides &&
        isIntersecting &&
        slides.map(slide => (
          <ImageContainer key={slide.id}>
            <SlideImage slide={slide} alt="" />
          </ImageContainer>
        ))}
    </Stack>
  )
}

// Hook
const useOnScreen = (ref, rootMargin = "-160px") => {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        if (entry.isIntersecting) setIntersecting(entry.isIntersecting)
      },
      {
        rootMargin
      }
    )
    if (ref.current) {
      observer.observe(ref.current)
    }
    return () => {
      observer.unobserve(ref.current)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Empty array ensures that effect is only run on mount and unmount

  return isIntersecting
}
